export default {
  install (app) {
    const rangeFn = (length) => Array.from(new Array(length), (_, idx) => idx);
    app.config.globalProperties.$range = rangeFn;
  }
};
